import {  UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { DropDownListCSSStyle, DropDownListCSSStyleImpl } from './dropdownlistcss';
import { DropDownListViewImpl } from './dropdownlistview';
import { ListViewModel } from '../horizontallist/listviewmodel';
import { VerticalListComponentProps } from '../verticallist/verticallistcomponent';

export interface DropDownListComponentProps<T> extends VerticalListComponentProps<T>
{
     listViewModel: ListViewModel<T>;
     cssStyle:DropDownListCSSStyle;
}


export class DropDownListComponent<T> extends UIComponentImpl<DropDownListComponentProps<T>, UIComponentState, UIDataModel> 
{
    constructor(props: DropDownListComponentProps<T>)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DropDownListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DropDownListCSSStyleImpl(applicationContext);
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistcomponent.tsx